<script>
    export let event;

    let ticketMessage = '';
    if (event.ticket_message) {
        ticketMessage = '* ' + event.ticket_message;
    }
</script>

<div class="text-center p-2">
    <small>{ticketMessage}</small>
</div>

<style>
    div {
        color: #F43B3F;
    }
</style>